import { render, staticRenderFns } from "./OdocDescriptionInput.vue?vue&type=template&id=d049e40e"
import script from "./OdocDescriptionInput.vue?vue&type=script&lang=js"
export * from "./OdocDescriptionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports